







































import Vue from "vue";
// @ts-ignore
import Organic from "@/libs/organic.min";
export default Vue.extend({
	name: "Organic",
	mounted() {
		this.initialize();
	},
	methods: {
		animate(organ: Organic, isActive: boolean, after: number) {
			return new Promise<boolean>((resolve) => {
				setTimeout(() => {
					organ.isActive = isActive;
					organ.animate();
					resolve(true);
				}, after);
			});
		},
		async initialize() {
			let organ = new Organic(this.$el);
			await this.animate(organ, true, 3000);
			await this.animate(organ, false, 5000);
		},
	},
});
